import getNamespacedFieldName from './getNamespacedFieldName';
import { withValue } from '@g4/automation-hooks';

// If two arguments: automationHook, namespace
// If three arguments: automationHook, fieldName, namespace
const getFormPartAutomationHook = (automationHook, ...rest) =>
  withValue(
    automationHook,
    (rest.length === 1 ? rest[0] : getNamespacedFieldName(...rest)).replace(
      /\./g,
      '_'
    )
  );

export default getFormPartAutomationHook;
